import { useCallback, useEffect, useState } from "react";

import { grantPurposeConsent, hasPurposeConsent, IUBENDA_PURPOSE, onConsentGranted } from "../../iubendaConsent";

// YouTube embeds set cookies, so nothing YouTube-shaped loads until the viewer consents to
// this purpose. Experience enhancement is the usual home for embedded video, and it's the
// only purpose the one tap grants.
export const YOUTUBE_CONSENT_PURPOSE = IUBENDA_PURPOSE.EXPERIENCE_ENHANCEMENT;

// How long a tap waits for the cookie tool to record it. Blockers like DuckDuckGo's stop
// iubenda loading at all, and then nothing is holding YouTube back either; the tap is the
// consent, so the video loads rather than the button silently doing nothing.
const COOKIE_TOOL_WAIT_MS = 3000;

// Whether YouTube may load yet, and the one-tap way to allow it. No consent controls
// installed (development, and anywhere the ENV flag is off) counts as consented.
export default function useYouTubeConsent() {
  const [consented, setConsented] = useState(false);

  useEffect(() => {
    onConsentGranted(YOUTUBE_CONSENT_PURPOSE, () => setConsented(true));
  }, []);

  const acceptCookies = useCallback(() => {
    grantPurposeConsent(YOUTUBE_CONSENT_PURPOSE);
    if (hasPurposeConsent(YOUTUBE_CONSENT_PURPOSE)) {
      setConsented(true);
      return;
    }
    setTimeout(() => setConsented(true), COOKIE_TOOL_WAIT_MS);
  }, []);

  return { acceptCookies, consented };
}
